import { CreateClientConfig } from "./client.gen/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL: "/api/v1",
});
